import { render, staticRenderFns } from "./bo-catalog-quick-add-popup.vue?vue&type=template&id=fbaca862"
import script from "./bo-catalog-quick-add-popup.vue?vue&type=script&lang=js"
export * from "./bo-catalog-quick-add-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports